import connect from './connect';
import { deleteCollection, editCollection } from '../actions/collections';
import EditCollectionDialog from './edit_collection_dialog.ui.jsx';
import { routeGoBack } from '../actions/route';

const mapStateToProps = state => ({ rootState: state });

export default connect(
    mapStateToProps,
    {
        deleteCollection,
        editCollection,
        routeGoBack,
    }
)(EditCollectionDialog);



// WEBPACK FOOTER //
// ./src/components/edit_collection_dialog.jsx